import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { CustomerTypeService } from '../../../services/customer-type.service';
import { LocationService } from '../../../services/location.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { ServiceReportService } from '../../../services/service-report.service';
import { ModalService } from '../../../services/modal.service';
import { CheckUserType } from '../../../models/checkUserType';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-service-report',
  templateUrl: './service-report.component.html',
  styleUrls: ['./service-report.component.css']
})
export class ServiceReportComponent implements OnInit {
  modalService: ModalService;
  role = new CheckUserType();
  client;

  filter: any = {
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
    out_Of_Service: false,
    quick_Search: ""
  };

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  showHistory: boolean = false;
  cylinder_Id: string;
  cylinder_Serial_No: string;

  availableOptions: string[] = [
    'Service Time', 
    'In/Out', 
    'Cylinder Serial #', 
    'User', 
    'Tag ID', 
    'Valve Serial #', 
    'Size', 
    'Product', 
    'Material', 
    'Valve Model #', 
    'Owner', 
    'Owner Acc #', 
    'Last Known Company', 
    'Last Known Acc #', 
    'Last Known Address 1', 
    'Last Known Postcode', 
    'Cyl Manuf Date', 
    'Cyl EOL', 
    'Cyl Last Test Date', 
    'Valve Manuf Date', 
    'Valve EOL', 
    'Valve Last Test Date'
];

selectedOptions: string[] = [
  'Service Time', 
  'In/Out', 
  'Cylinder Serial #', 
  'Tag ID', 
  'Valve Serial #', 
  'Size', 
  'Product', 
  'Material', 
  'Valve Model #', 
  'Last Known Company'
];


  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService, public serviceReportService: ServiceReportService,
    customerTypeService: CustomerTypeService, public router: Router, modalService: ModalService, private columnService: ColumnService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);
    this.modalService = modalService;

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    this.loadTable(this.page);

  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  outOfService() {
  }

  openCylHistoryPopup(row) {
    this.showHistory = true;

    this.cylinder_Id = row.cylinder_ID;
    this.cylinder_Serial_No = row.cyl_Serial_Num;

    this.modalService.open('popup-cyl-history');
  }

  closeCylHistoryPopup(): void {
    if (!this.showHistory) {
      return;
    }
    this.showHistory = false;
    this.modalService.close('popup-cyl-history');
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {

    if (!event.column.prop) {
      return false;
    }

    const sortMapping = {
      'service_Time_Display': 'service_Time_Sorting',
      'user' : 'firstname'
    };

    const sortOrder = event.newValue;
    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = sortOrder;
    this.page.sortBy = sortBy;

    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.serviceReportService.getResults(this.page, this.filter.start_Date, this.filter.end_Date, this.filter.out_Of_Service, this.filter.quick_Search).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;

      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.serviceReportService.getExcel(this.page, this.filter.start_Date, this.filter.end_Date, this.filter.out_Of_Service, this.filter.quick_Search).then((data) => {
      importedSaveAs(data, 'Service.xlsx');
    });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "serviceReport").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "serviceReport", this.selectedOptions).then((data) => {
    });
  }
}

